import { render, staticRenderFns } from "./TestCalendarView.vue?vue&type=template&id=52a312ea"
import script from "./TestCalendarView.vue?vue&type=script&lang=js"
export * from "./TestCalendarView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports